import { render, staticRenderFns } from "./ProgressDetails.vue?vue&type=template&id=16bdf87c&scoped=true&"
import script from "./ProgressDetails.vue?vue&type=script&lang=ts&"
export * from "./ProgressDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressDetails.vue?vue&type=style&index=0&id=16bdf87c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bdf87c",
  null
  
)

export default component.exports